// src/pages/Admin/AdminLogin.jsx
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";

const AdminLogin = () => {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");

  const handleLogin = async (e) => {
    e.preventDefault();
    setMessage("");

    if (!email || !username || !password) {
      setMessage("🚫 সব ফিল্ড পূরণ করুন!");
      return;
    }

    setLoading(true);

    try {
      const res = await fetch("https://api.earnmoney0.top/admin/login", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email, username, password }),
      });

      const data = await res.json();

      if (!res.ok) {
        setMessage(data.message || "❌ লগইন ব্যর্থ হয়েছে, তথ্য পরীক্ষা করুন");
        setLoading(false);
        return;
      }

      // Success → save token & admin info
      localStorage.setItem("adminToken", data.token);
      localStorage.setItem("adminInfo", JSON.stringify(data.admin));

      setMessage("✅ লগইন সফল হয়েছে! Dashboard এ নিয়ে যাওয়া হচ্ছে...");
      setTimeout(() => navigate("/admin/dashboard"), 1000);
    } catch (err) {
      console.error(err);
      setMessage("❌ সার্ভার এরর, পরে চেষ্টা করুন");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={styles.page}>
      <div style={styles.card}>
        <h2 style={styles.title}>Admin Login</h2>
        <form onSubmit={handleLogin} style={styles.form}>
          {message && <p style={{ color: "#f87171", textAlign: "center" }}>{message}</p>}

          <label style={styles.label}>Gmail:</label>
          <input
            type="email"
            placeholder="example@gmail.com"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            style={styles.input}
          />

          <label style={styles.label}>Username:</label>
          <input
            type="text"
            placeholder="Username"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            style={styles.input}
          />

          <label style={styles.label}>Password:</label>
          <input
            type="password"
            placeholder="Password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            style={styles.input}
          />

          <button type="submit" style={styles.button} disabled={loading}>
            {loading ? "Logging in..." : "Login"}
          </button>
        </form>
      </div>
    </div>
  );
};

const styles = {
  page: {
    minHeight: "100vh",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    background: "#0f172a",
    color: "#fff",
    fontFamily: "sans-serif",
  },
  card: {
    background: "#1e293b",
    padding: "30px 40px",
    borderRadius: 12,
    width: 350,
    boxShadow: "0 4px 12px rgba(0,0,0,0.5)",
  },
  title: {
    marginBottom: 20,
    color: "#facc15",
    textAlign: "center",
  },
  form: {
    display: "flex",
    flexDirection: "column",
    gap: 12,
  },
  label: {
    fontSize: 14,
    fontWeight: 600,
    marginBottom: 4,
  },
  input: {
    padding: "8px 12px",
    borderRadius: 6,
    border: "1px solid #ccc",
    fontSize: 14,
  },
  button: {
    marginTop: 12,
    padding: "10px 0",
    borderRadius: 6,
    border: "none",
    background: "#22c55e",
    color: "#0f172a",
    fontWeight: 600,
    cursor: "pointer",
    fontSize: 16,
    transition: "0.3s",
  },
};

export default AdminLogin;